import Icon from "./Icon";
import { ST_CLR, ST_ICON, PR_CLR, PR_BG } from "../constants";
import { ringClr } from "../utils";

export function Avatar({ name, color="#6b7280", size=28 }) {
  return (
    <div style={{width:size,height:size,borderRadius:"50%",background:color+"22",color,
      border:`1.5px solid ${color}44`,display:"flex",alignItems:"center",justifyContent:"center",
      fontWeight:700,fontSize:size*.38,flexShrink:0}}>
      {name?.[0]?.toUpperCase()}
    </div>
  );
}

export function Badge({ label, color, bg, style={} }) {
  return (
    <span className="chip" style={{fontSize:11,fontWeight:700,padding:"3px 8px",borderRadius:20,
      background:bg,color,letterSpacing:".03em",display:"inline-flex",alignItems:"center",...style}}>
      {label}
    </span>
  );
}

// Barra de progreso. Por dentro son las clases .kpi-track / .kpi-fill que ya
// existen en constants.js y que KpisView pinta a mano en media docena de sitios;
// aqui solo se les pone un nombre para no repetir el par de divs ni el acotado
// del porcentaje, que es donde se cuela el fallo.
//
// `valor` null NO es cero: deja la pista vacia, que es como se dice "sin dato".
// `marca` pinta una rayita vertical en ese porcentaje, para poder enseñar donde
// deberia ir el relleno sin inventar una segunda barra.
export function Barra({ valor, color="var(--accent)", alto=6, marca=null, title }) {
  const pct = valor === null || valor === undefined
    ? null : Math.max(0, Math.min(100, Number(valor) || 0));
  const pctMarca = marca === null || marca === undefined
    ? null : Math.max(0, Math.min(100, Number(marca) || 0));
  return (
    <div className="kpi-track" title={title}
      style={{height:alto, position:"relative", marginBottom:0}}>
      {pct !== null && (
        <span className="kpi-fill" style={{display:"block",width:`${pct}%`,background:color}} />
      )}
      {pctMarca !== null && (
        <span style={{position:"absolute",left:`${pctMarca}%`,top:-1,bottom:-1,width:1.5,
          background:"var(--text2)",borderRadius:1}} />
      )}
    </div>
  );
}

export function BtnPrimary({ onClick, disabled, children, style={} }) {
  return (
    <button className="btn" onClick={onClick} disabled={disabled}
      style={{padding:"8px 16px",background:"var(--accent)",color:"var(--on-accent)",
        border:"none",borderRadius:9,cursor:disabled?"not-allowed":"pointer",fontWeight:600,fontSize:13,
        fontFamily:"var(--font)",opacity:disabled?.5:1,boxShadow:"0 2px 8px rgba(0,150,200,.2)",
        display:"inline-flex",alignItems:"center",gap:6,...style}}>
      {children}
    </button>
  );
}

export function BtnGhost({ onClick, children, style={}, title }) {
  return (
    <button className="btn" onClick={onClick} title={title}
      style={{padding:"6px 13px",background:"var(--surface)",color:"var(--text2)",
        border:"1px solid var(--border)",borderRadius:8,cursor:"pointer",fontSize:12,fontWeight:600,
        fontFamily:"var(--font)",display:"inline-flex",alignItems:"center",gap:5,...style}}>
      {children}
    </button>
  );
}

export function StatusIcon({ status, size=14 }) {
  return <Icon name={ST_ICON[status]||"inbox"} size={size} color={ST_CLR[status]||"#6b7280"}/>;
}

/** Sortable <th>. Pass sortKey, cfg={key,dir}, onSort handler, and base thStyle. */
export function SortTh({ children, sortKey, cfg, onSort, style={} }) {
  const active = cfg?.key === sortKey;
  return (
    <th onClick={()=>onSort(sortKey)}
      style={{cursor:"pointer",userSelect:"none",...style}}
      title={active?(cfg.dir==="asc"?"Ordenar descendente":"Quitar orden"):"Ordenar"}>
      <span style={{display:"inline-flex",alignItems:"center",gap:4}}>
        {children}
        <span style={{fontSize:11,lineHeight:1,color:active?"var(--accent)":"var(--text3)",opacity:active?1:.4,fontWeight:700}}>
          {!active?"↕":cfg.dir==="asc"?"↑":"↓"}
        </span>
      </span>
    </th>
  );
}




export const ModalFt = ({onClose, label, onSave, disabled}) => (
  <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:6}}>
    <button className="btn" onClick={onClose} style={{padding:"8px 16px",borderRadius:9,border:"1px solid var(--border)",cursor:"pointer",fontSize:13,background:"var(--surface2)",color:"var(--text2)",fontFamily:"var(--font)"}}>Cancelar</button>
    <BtnPrimary onClick={onSave} disabled={disabled}>{label}</BtnPrimary>
  </div>
);
